



































































































































import {Component, Vue} from '@/shared/component';
import {Stored} from "vue-stored-prop-decorator";
import {ResultType} from "@/shared/xhttp";

import storeUser from '@/stores/modules/user';
import storeCommande from '@/stores/modules/commande';
import CrudEssenceAchatFilterTotauxEssenceAchats
	from "@/components/Crud/EssenceAchat/FilterTotauxEssenceAchats.vue";
import CrudEssenceAchatFilterRechercheEssenceAchats
	from "@/components/Crud/EssenceAchat/FilterRechercheEssenceAchats.vue";
import CrudEssenceAchatListTotauxEssenceAchats from "@/components/Crud/EssenceAchat/ListTotauxEssenceAchats.vue";
import CrudVenteFilterTotauxVentes from "@/components/Crud/Vente/FilterTotauxVentes.vue";
import CrudVenteListTotauxVentes from "@/components/Crud/Vente/ListTotauxVentes.vue";

import DxScheduler, { DxResource } from 'devextreme-vue/scheduler';
import {Commande, User, Vente} from "@/models";
import storeVente from '@/stores/modules/vente';
import CrudVenteEditDialog from "@/components/Crud/Vente/EditDialog.vue";
import CustomStore from 'devextreme/data/custom_store';
import 'whatwg-fetch';
import CrudVenteAppointment from "@/components/Crud/Vente/Appointment.vue";
import DxButton from "devextreme-vue/button";
import CrudCommandeFilter from "@/components/Crud/Commande/Filter.vue";
import CrudCommandeEditDialog from "@/components/Crud/Commande/EditDialog.vue";
import CrudCommandeList from "@/components/Crud/Commande/List.vue";
import CrudDeleteDialog from "@/components/Crud/DeleteDialog.vue";
import {Emit} from "vue-property-decorator";

@Component({
	components: {
		CrudEssenceAchatFilterTotauxEssenceAchats,
		CrudEssenceAchatListTotauxEssenceAchats,
		CrudVenteFilterTotauxVentes,
		CrudVenteListTotauxVentes,
		CrudVenteEditDialog,
		CrudVenteAppointment,
		CrudCommandeFilter,
		CrudCommandeEditDialog,
		CrudCommandeList,
		CrudDeleteDialog,
		DxScheduler,
		DxResource,
		DxButton,
	}
})
export default class HomeView extends Vue {

	@Stored(() => storeUser) me!: User;

	private panel : number = 0;

	private editCommande: Commande = null;
	private deletedCommande: Commande = null;
	private storeCommande = storeCommande;

	private views = ['day', 'workWeek', 'month']

	private currentDate = new Date()

	private editVente: Vente = null;
	private storeVente = storeVente;
	private scheduler = null;

	private refresh(): void {
		storeCommande.dispatch('getCommandes');
	}

	@Emit()
	private onCreate(): void {
		this.editCommande = new Commande();
	}

	@Emit()
	private onCreateExpedition(): void {
		this.editVente = new Vente();
	}

	private handleErrors(response) {
		if (!response.ok) {
			throw Error(response.statusText);
		}
		return response;
	}

	onContentReady(e) {
		this.scheduler = e.component;
	}

	private customDataSource = new CustomStore({
		key: 'Id',
		load: (options) => {
			return fetch(`${process.env.VUE_APP_BACK_BASE_URL}/api/ventes/planning?filter=${ JSON.stringify(options['filter']) }`, {
				headers:{
					'Authorization': 'BEARER ' + this.me.currentToken.id
				}
			})
				.then(this.handleErrors)
				.then(response => response.json())
				.catch(() => { throw 'Network error' });
		},
		remove: (data) => {
			return fetch(`${process.env.VUE_APP_BACK_BASE_URL}/api/ventes/${encodeURIComponent(data)}`, {
				method: 'DELETE',
				headers:{
					'Authorization': 'BEARER ' + this.me.currentToken.id
				}
			})
				.then(this.handleErrors)
				.catch(() => { throw 'Network error' });
		},
		update: (key, values) => {
			return fetch(`${process.env.VUE_APP_BACK_BASE_URL}/api/ventes/planning/${encodeURIComponent(key)}`, {
				method: 'PUT',
				body: JSON.stringify(values),
				headers:{
					'Content-Type': 'application/json',
					'Authorization': 'BEARER ' + this.me.currentToken.id
				}
			})
				.then(this.handleErrors)
				.catch(() => { throw 'Network error' });
		}
	});

	private closedDialog() {
		this.scheduler.getDataSource().reload();
	}

	private async onAppointmentFormOpening (e): Promise<void> {
		console.log(e)
		e.cancel = true;
		if (e.appointmentData.Id) {
			await storeVente.dispatch('get', e.appointmentData.Id)
			this.editVente = this.storeVente.state.vente
		} else {
			let vente = new Vente()
			vente.date = e.appointmentData.StartDate.substr(0,10)
			vente.hours = e.appointmentData.StartDate.substr(11,5)
			this.editVente = vente;
		}
	}

	private dataSource = [{
		text: 'Website Re-Design Plan',
		startDate: new Date('2021-11-17T16:00:00'),
		endDate: new Date('2021-11-17T16:00:00'),
		allDay: true
	}]

	private editing = { allowAdding: false }

	public created(): void {

		//console.log("created");
	}

	public async mounted(): Promise<void> {
		this.addEventDom(window, 'resize', () => this.$forceUpdate());
		//console.log("mounted");
	}

	private get chart_title(): string
	{
		return "Bois en stock";
	}

}
